import React from 'react'

import { Card, CardContent, CardHeader } from '@mui/material'
import CustomerEditForm from 'features/customers/components/edit/CustomerEditForm'
import { useCustomer } from 'features/customers/hooks/useCustomer'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'
import { useCustomerUpdate } from 'features/customers/hooks/useCustomerUpdate'
import { useNavigate } from 'react-router-dom'
import { UrlProvider } from 'urls'

import LoadingView from 'components/LoadingView'

import { useCustomerInternalData } from '../hooks/useCustomerInternalData'
import { useCustomerStripeIdUpdate } from '../hooks/useCustomerStripeIdUpdate'

const CustomerEdit = () => {
  const customerId = useCustomerId()
  const navigate = useNavigate()

  const { data, isLoading } = useCustomer(customerId)
  const internalData = useCustomerInternalData()
  const { mutateAsync: updateCustomer } = useCustomerUpdate(customerId)
  const customerStripeId = useCustomerStripeIdUpdate(customerId)

  const initialValues = {
    ...data,
    internalData: internalData.data,
  }

  const handleSubmit = async (values: any) => {
    const { internalData: internalDataValues, stripe_customer_id, ...customer } = values
    if (initialValues.stripe_customer_id !== stripe_customer_id) {
      await customerStripeId.update(stripe_customer_id)
    }
    await updateCustomer(customer)
    await internalData.update(internalDataValues)

    navigate(UrlProvider.getUrl('customer', { id: customerId, tab: '' }))
  }

  return (
    <Card>
      <CardHeader title="Customer Edit" />
      <CardContent>
        <LoadingView loading={isLoading || customerStripeId.isPending}>
          <CustomerEditForm id={customerId} initialValues={initialValues} onSubmit={handleSubmit} />
        </LoadingView>
      </CardContent>
    </Card>
  )
}

export default CustomerEdit
